module.exports = __webpack_public_path__ + "static/media/time.f2ccf594.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Benefit/time.svg
// module id = 56
// module chunks = 0